import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import PayBalance from "@/pages/PayBalance";

export const Route = createFileRoute("/_public/pay-balance/$token")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Pay your fence install balance \u2014 Modern Fence Install", "Secure payment for your fence installation.", undefined, true),
  component: PayBalance,
});
